export default "__VITE_ASSET__QfTNMtK2__"